import { defineStore } from "pinia";
import { getCurrentUserCompanyDept, type Options } from "@/apis/common";

// 对象数组去重
const uniqueByProperty = (arr: Options[], property: string ) => {
	return arr.filter((item, index) => {
		return arr.findIndex((i) => { return i[property] === item[property]; }) === index;
	});
};

// 定义store
export const useUserCompanyDeptStore = defineStore({
	id: "userCompanyDept",
	state: () => {
		return {
			companyList: [] as Options[],
			deptList: [] as Options[],
			companyListCombination: [] as any
		};
	},
	actions: {
		async fetchUserCompanyDept() {
			try {
				const res = await getCurrentUserCompanyDept();
				if (res.responseData && Array.isArray(res.responseData)) {
					this.companyList = uniqueByProperty(res.responseData.map(item => {
						return {
							value: item.companyCode,
							label: item.companyName
						};
					}), "value");
					this.deptList = res.responseData.map(item => {
						return {
							value: item.deptCode,
							label: item.deptName,
							companyCode: item.companyCode
						};
					});
					// 组合数据
					const list = res.responseData;
					let arr = [];
					for(let item of list) {
						arr.push({
							value: item.companyCode + "-" + item.deptCode,
							label: item.companyName + " - " + item.deptName,
							companyCode: item.companyCode,
							deptCode: item.deptCode,
							companyName: item.companyName,
							deptName: item.deptName
						});
					}
					this.companyListCombination = arr;
				}
			} catch (error) {
				console.error("Failed to fetch supplier detail:", error);
			}
		}
	}
});
